import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const AnimateRotate = keyframes`
100% {
  transform: rotate(360deg);
} 0% {
  transform: rotate(0);
}`;

export const StyledFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 24px 0;

  .filter-area {
    display: flex;
    align-items: center;

    & > * + * {
      margin-left: 15px;
    }
  }
`;

export const StyledPDFButton = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;

  width: 108px;
  height: 40px;
  border-radius: 40px;
  font-size: 18px;

  border: unset;
  background: #00bf00;
  color: #ffffff;
  :hover {
    background: #2de100;
  }
  :active {
    background: 127, 225, 0;
  }
  :disabled {
    cursor: not-allowed;
    background-color: #999999;
    :hover {
      background: #999999;
    }
    :active {
      background: #999999;
    }
  }
`;

export const StyledProgress = styled.div`
  width: 15px;
  height: 15px;
  border: 3px solid;
  border-color: white white rgba(255, 255, 255, 0.6) white;
  border-radius: 15px;
  animation: ${AnimateRotate} 2s linear infinite;
`;

export const SearchInputStyle = css`
  width: 200px;
`;
